var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGhost = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "var(--color-primary)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.40002 8.42646C4.40002 5.46965 6.76282 2.89113 9.82794 2.80254C12.9992 2.71085 15.6 5.16253 15.6 8.20005V15.8493C15.6 16.25 15.0975 16.4509 14.8035 16.1674L14.0767 15.6462C13.8824 15.5067 13.61 15.534 13.4493 15.7084L12.1966 17.0682C12.0143 17.244 11.7188 17.244 11.5365 17.0682L10.3489 15.7787C10.1634 15.577 9.83698 15.577 9.65119 15.7787L8.46352 17.0682C8.28123 17.244 7.98577 17.244 7.80348 17.0682L6.55077 15.7084C6.39007 15.534 6.11765 15.507 5.9234 15.6462L5.19657 16.1674C4.90257 16.4509 4.40002 16.2503 4.40002 15.8493V8.42646ZM6.80002 8.20005C6.80002 7.64776 7.24774 7.20005 7.80002 7.20005C8.35231 7.20005 8.80002 7.64776 8.80002 8.20005C8.80002 8.75233 8.35231 9.20005 7.80002 9.20005C7.24774 9.20005 6.80002 8.75233 6.80002 8.20005ZM12.2 7.20005C11.6477 7.20005 11.2 7.64776 11.2 8.20005C11.2 8.75233 11.6477 9.20005 12.2 9.20005C12.7523 9.20005 13.2 8.75233 13.2 8.20005C13.2 7.64776 12.7523 7.20005 12.2 7.20005Z",
  fill: "white"
})));
export default SvgGhost;